import React from "react";

const TotalBlock = (props) => {
  const { dataBlock, darkMode } = props;
  //console.log(data);

  const renderIcon = (title) => {
    let iconClass = "icon ";

    switch (title) {
      case "facebook":
        iconClass += "icon-fb";
        break;
      case "instagram":
        iconClass += "icon-insta";
        break;
      case "twitter":
        iconClass += "icon-twtr";
        break;
      case "youtube":
        iconClass += "icon-yt";
        break;
      default:
    }
    console.log(iconClass);
    return <i className={iconClass} />;
  };

  const renderValue = (value) => {
    if (value >= 10000) {
      return `${Math.floor(value / 1000)}k`;
    }
    return value;
  };

  const renderToday = (lastValue, currentValue) => {
    const trend = currentValue - lastValue;
    let iconClass = "icon icon-up";
    let textClass = "up-color";
    iconClass = trend < 0 ? "icon icon-down" : iconClass;
    textClass = trend < 0 ? "down-color" : textClass;
    return (
      <React.Fragment>
        <i className={iconClass} />
        <span className={textClass}>{dataBlock.followCurrent} Today</span>
      </React.Fragment>
    );
  };

  const blockBorderClass = (title) => {
    const borderClass = "totalblock";
    switch (title) {
      case "facebook":
        return borderClass + " totalblock-fb";
      case "twitter":
        return borderClass + " totalblock-twtr";
      case "instagram":
        return "totalblock-insta";
      case "youtube":
        return borderClass + " totalblock-yt";
      default:
    }
  };

  return (
    <div
      className={
        blockBorderClass(dataBlock.title) +
        (darkMode ? " card_dark" : " card_light")
      }>
      <div className={"totalblock_name dashboard_dark_secondarytext"}>
        {renderIcon(dataBlock.title)}
        <span>{dataBlock.name}</span>
      </div>
      <div
        className={
          darkMode
            ? "totalBlock-mainvalue dashboard_dark_maintext"
            : "totalBlock-mainvalue dashboard_light_maintext"
        }>
        {renderValue(dataBlock.totalFollowers)}
      </div>
      <div className="totalblock-followers dashboard_dark_secondarytext">
        {dataBlock.title === "youtube" ? "SUBSCRIBERS" : "FOLLOWERS"}
      </div>
      <div className="trend">
        {renderToday(dataBlock.followLast, dataBlock.followCurrent)}
      </div>
    </div>
  );
};

export default TotalBlock;
